module.exports = __webpack_public_path__ + "img/direction-down.7134d79e.svg";